// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BookingService from 'services/BookingService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import BookingInvoiceModal from 'components/invoicing/BookingInvoiceModal';
import MissingBookingModal from 'components/invoicing/MissingBookingModal';
import BookingsTable from 'components/bookings/BookingsTable';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class InstructorInvoicesPage extends React.Component {

    constructor(props) {
        super(props);

        this.bookingInvoiceModalRef = React.createRef();
        this.missingBookingModalRef = React.createRef();

        this.requestID = 1;

        this.state = {
            isLoading: true
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    componentDidUpdate(oldProps) {
        const oldParams = this.getParams(oldProps.match.params);
        const newParams = this.getParams(this.props.match.params);
        if (newParams.slug != oldParams.slug || newParams.tab != oldParams.tab) {
            this.load();
        }
    }
    
    getParams(params) {
        if (typeof (params) == 'undefined') {
            params = this.props.match.params;
        }
        let { slug } = params;
        if (slug == 'null') {
            slug = '';
        }
        return {
            slug: (slug || '')
        };
    }

    async load() {
        this.setState({
            isLoading: true
        });

        GlobalStateService.setValues({
            area: 'invoicing'
        });

        this.requestID++;

        const newState = {};

        // Bookings awaiting invoice
        newState.bookings = await BookingService.list({
            isInvoicing: true,
            goCoursesInvoiceStatus: 'NotInvoiced'
        });

        // My sent invoices
        newState.sentInvoices = await BookingService.list({
            isInvoicing: true,
            goCoursesInvoiceStatus: 'Invoiced'
        });

        newState.isLoading = false;
        this.setState(newState);
    }

    async showContactModal() {
        this.missingBookingModalRef.current.show({

        });
    }

    render() {
        const {
            isLoading
        } = this.state;

        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>
            <div className="page instructor-invoicing-page">

                <PageHeader>
                    <h1>
                        Invoicing
                    </h1>
                    {loginInfo.isManager && loginInfo.instructor &&
                        <h2>
                            {` for ${loginInfo.instructor.firstName} ${loginInfo.instructor.lastName}`}
                        </h2>
                    }

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.showContactModal()}>
                            <span className="fa-solid fa-exclamation-triangle"></span>{' '}
                            I can't see my completed booking
                        </button>

                    </div>
                </PageHeader>

                <main>

                    <Container>


                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <BookingInvoiceModal ref={this.bookingInvoiceModalRef} />
            <MissingBookingModal ref={this.missingBookingModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            bookings,
            sentInvoices
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>

            <h2>Bookings awaiting invoice</h2>
                
            <BookingsTable
                mode="invoices"
                isScrolling
                requestID={this.requestID}
                instructorID={loginInfo.instructor.id}
                bookings={bookings}
                isEditMode
                loginInfo={loginInfo}
                emptyText="You have no bookings that are awaiting invoices"
                onClick={async (booking) => {
                    await this.bookingInvoiceModalRef.current.show({
                        bookingID: booking.id
                    });
                    this.load();
                }}
            />

            <h2>My invoices</h2>
            <BookingsTable
                isScrolling
                mode="invoices"
                requestID={this.requestID}
                instructorID={loginInfo.instructor.id}
                bookings={sentInvoices}
                isEditMode
                loginInfo={loginInfo}
                emptyText="You have no invoiced bookings"
                onClick={async (booking) => {
                    await this.bookingInvoiceModalRef.current.show({
                        bookingID: booking.id
                    });
                    this.load();
                }}
            />

        </>);
    }

}

export default withRouter(InstructorInvoicesPage);